import { IonModal } from '@ionic/react';
import { alertCircleOutline } from 'ionicons/icons';
import React from 'react';
import ModalHeader from '../Modal/ModalHeader';

type ExitConfirmModalProps = {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
};

const ExitConfirmModal: React.FC<ExitConfirmModalProps> = ({ isOpen, onStay, onLeave }) => (
  <IonModal className="xeguei-dialog" isOpen={isOpen} onDidDismiss={onStay}>
    <div className="xeguei-dialog-panel">
      <ModalHeader title="Sair da configuração?" icon={alertCircleOutline} layout="compact" onDismiss={onStay} />
      <div className="xeguei-dialog-body">
        <p>Você ainda não concluiu todas as configurações. Sua loja pode não receber pedidos corretamente.</p>
      </div>
      <footer className="xeguei-dialog-footer">
        <button type="button" className="xeguei-modal-secondary" onClick={onLeave}>Sair</button>
        <button type="button" className="xeguei-modal-primary" onClick={onStay}>Continuar configurando</button>
      </footer>
    </div>
  </IonModal>
);
export default ExitConfirmModal;
